var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M351.028 144.402H223.873c-11.207 0-20.291 9.083-20.291 20.291 0 11.207 9.083 20.291 20.291 20.291h127.155c11.214 0 20.291-9.083 20.291-20.291-.001-11.208-9.084-20.291-20.291-20.291zM399.725 242.473H223.873c-11.207 0-20.291 9.083-20.291 20.291 0 11.207 9.083 20.291 20.291 20.291h175.852c11.207 0 20.291-9.083 20.291-20.291s-9.084-20.291-20.291-20.291z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.709 17.247H132.565c-11.207 0-20.291 9.083-20.291 20.291v191.408H76.428C34.284 228.946 0 263.237 0 305.374v112.951c0 42.144 34.284 76.428 76.428 76.428 3.449 0 6.845-.23 10.166-.676h334.775c49.969 0 90.631-40.656 90.631-90.631V37.538c0-11.208-9.083-20.291-20.291-20.291zM112.275 418.325c0 17.389-12.452 31.931-28.907 35.17h-6.939v.676c-19.77 0-35.847-16.084-35.847-35.847v-112.95c0-19.763 16.084-35.847 35.847-35.847h35.847v148.798zm359.144-14.88c0 27.129-22.915 50.05-50.05 50.05H144.273c5.485-10.531 8.583-22.496 8.583-35.17V57.828h318.563v345.617z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.028 334.464H223.873c-11.207 0-20.291 9.083-20.291 20.291 0 11.207 9.083 20.291 20.291 20.291h127.155c11.214 0 20.291-9.083 20.291-20.291-.001-11.208-9.084-20.291-20.291-20.291z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.6d85df80756f4b169486fc6b2d9bdfd6.svg";
export { ForwardRef as ReactComponent };